var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 33,
    viewBox: "0 0 49 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 33,
    rx: 4,
    fill: "url(#paint0_linear_1_5441)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 13,
    height: 33,
    rx: 4,
    fill: "url(#paint1_linear_1_5441)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 13,
    height: 33,
    rx: 4,
    fill: "url(#paint2_linear_1_5441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5441",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#630606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5441",
    x1: 24.5,
    y1: 0,
    x2: 24.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5441",
    x1: 42.5,
    y1: 0,
    x2: 42.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003269"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData1);
export default __webpack_public_path__ + "static/media/data1.7032e3e01e2ee447f126a75e983c159d.svg";
export { ForwardRef as ReactComponent };